var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgramming(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "50pt",
    viewBox: "0 0 937.5 937.5",
    width: "50pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 875 125 L 875 156.25 C 892.261719 156.25 906.25 170.238281 906.25 187.5 L 906.25 656.25 L 31.25 656.25 L 31.25 187.5 C 31.25 170.238281 45.238281 156.25 62.5 156.25 L 62.5 125 C 27.984375 125 0 152.984375 0 187.5 L 0 718.75 C 0 753.265625 27.984375 781.25 62.5 781.25 L 369.625 781.25 L 332.125 906.25 L 296.875 906.25 L 296.875 937.5 L 640.625 937.5 L 640.625 906.25 L 605.375 906.25 L 567.875 781.25 L 875 781.25 C 909.515625 781.25 937.5 753.265625 937.5 718.75 L 937.5 187.5 C 937.5 152.984375 909.515625 125 875 125 Z M 572.75 906.25 L 364.75 906.25 L 402.25 781.25 L 535.25 781.25 Z M 906.25 718.75 C 906.25 736.011719 892.261719 750 875 750 L 62.5 750 C 45.238281 750 31.25 736.011719 31.25 718.75 L 31.25 687.5 L 906.25 687.5 Z M 906.25 718.75 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.25 625 L 781.25 625 C 815.765625 625 843.75 597.015625 843.75 562.5 L 843.75 62.5 C 843.75 27.984375 815.765625 0 781.25 0 L 156.25 0 C 121.734375 0 93.75 27.984375 93.75 62.5 L 93.75 562.5 C 93.75 597.015625 121.734375 625 156.25 625 Z M 125 62.5 C 125 45.238281 138.988281 31.25 156.25 31.25 L 781.25 31.25 C 798.511719 31.25 812.5 45.238281 812.5 62.5 L 812.5 562.5 C 812.5 579.761719 798.511719 593.75 781.25 593.75 L 156.25 593.75 C 138.988281 593.75 125 579.761719 125 562.5 Z M 125 62.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.25 125 L 781.25 125 L 781.25 156.25 L 156.25 156.25 Z M 156.25 125 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.25 203.125 L 296.875 203.125 L 296.875 234.375 L 156.25 234.375 Z M 156.25 203.125 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.25 265.625 L 265.625 265.625 L 265.625 296.875 L 156.25 296.875 Z M 156.25 265.625 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.25 328.125 L 250 328.125 L 250 359.375 L 156.25 359.375 Z M 156.25 328.125 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.25 390.625 L 250 390.625 L 250 421.875 L 156.25 421.875 Z M 156.25 390.625 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.25 453.125 L 250 453.125 L 250 484.375 L 156.25 484.375 Z M 156.25 453.125 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.25 515.625 L 296.875 515.625 L 296.875 546.875 L 156.25 546.875 Z M 156.25 515.625 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 640.625 203.125 L 781.25 203.125 L 781.25 234.375 L 640.625 234.375 Z M 640.625 203.125 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 671.875 265.625 L 781.25 265.625 L 781.25 296.875 L 671.875 296.875 Z M 671.875 265.625 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 687.5 328.125 L 781.25 328.125 L 781.25 359.375 L 687.5 359.375 Z M 687.5 328.125 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 687.5 390.625 L 781.25 390.625 L 781.25 421.875 L 687.5 421.875 Z M 687.5 390.625 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 687.5 453.125 L 781.25 453.125 L 781.25 484.375 L 687.5 484.375 Z M 687.5 453.125 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 640.625 515.625 L 781.25 515.625 L 781.25 546.875 L 640.625 546.875 Z M 640.625 515.625 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.25 62.5 L 187.5 62.5 L 187.5 93.75 L 156.25 93.75 Z M 156.25 62.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 218.75 62.5 L 250 62.5 L 250 93.75 L 218.75 93.75 Z M 218.75 62.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 281.25 62.5 L 312.5 62.5 L 312.5 93.75 L 281.25 93.75 Z M 281.25 62.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 595.566406 435.515625 C 597.679688 431.0625 599.5625 426.515625 601.21875 421.875 L 640.625 421.875 C 649.257812 421.875 656.25 414.882812 656.25 406.25 L 656.25 343.75 C 656.25 335.117188 649.257812 328.125 640.625 328.125 L 601.21875 328.125 C 599.5625 323.484375 597.679688 318.9375 595.566406 314.484375 L 623.4375 286.609375 C 629.539062 280.511719 629.539062 270.617188 623.4375 264.523438 L 579.226562 220.3125 C 573.132812 214.210938 563.238281 214.210938 557.140625 220.3125 L 529.265625 248.167969 C 524.8125 246.0625 520.265625 244.179688 515.625 242.53125 L 515.625 203.125 C 515.625 194.492188 508.632812 187.5 500 187.5 L 437.5 187.5 C 428.867188 187.5 421.875 194.492188 421.875 203.125 L 421.875 242.53125 C 417.234375 244.1875 412.6875 246.070312 408.234375 248.183594 L 380.359375 220.3125 C 374.261719 214.210938 364.367188 214.210938 358.273438 220.3125 L 314.0625 264.523438 C 307.960938 270.617188 307.960938 280.511719 314.0625 286.609375 L 341.917969 314.484375 C 339.804688 318.9375 337.921875 323.484375 336.269531 328.125 L 296.875 328.125 C 288.242188 328.125 281.25 335.117188 281.25 343.75 L 281.25 406.25 C 281.25 414.882812 288.242188 421.875 296.875 421.875 L 336.28125 421.875 C 337.9375 426.515625 339.820312 431.0625 341.933594 435.515625 L 314.0625 463.390625 C 307.960938 469.488281 307.960938 479.382812 314.0625 485.476562 L 358.273438 529.6875 C 364.367188 535.789062 374.261719 535.789062 380.359375 529.6875 L 408.234375 501.832031 C 412.6875 503.945312 417.234375 505.828125 421.875 507.480469 L 421.875 546.875 C 421.875 555.507812 428.867188 562.5 437.5 562.5 L 500 562.5 C 508.632812 562.5 515.625 555.507812 515.625 546.875 L 515.625 507.46875 C 520.265625 505.8125 524.8125 503.929688 529.265625 501.816406 L 557.140625 529.6875 C 563.238281 535.789062 573.132812 535.789062 579.226562 529.6875 L 623.4375 485.476562 C 629.539062 479.382812 629.539062 469.488281 623.4375 463.390625 Z M 568.183594 496.453125 L 543.1875 471.445312 C 538.144531 466.40625 530.328125 465.421875 524.179688 469.046875 C 515.40625 474.21875 505.933594 478.132812 496.0625 480.6875 C 489.164062 482.46875 484.34375 488.679688 484.34375 495.8125 L 484.34375 531.25 L 453.125 531.25 L 453.125 495.902344 C 453.125 488.78125 448.300781 482.558594 441.40625 480.78125 C 431.53125 478.234375 422.066406 474.3125 413.28125 469.140625 C 407.140625 465.515625 399.320312 466.5 394.28125 471.554688 L 369.277344 496.542969 L 347.191406 474.457031 L 372.1875 449.457031 C 377.234375 444.410156 378.222656 436.59375 374.601562 430.449219 C 369.421875 421.671875 365.503906 412.203125 362.949219 402.335938 C 361.175781 395.433594 354.953125 390.617188 347.832031 390.617188 L 312.5 390.617188 L 312.5 359.375 L 347.847656 359.375 C 354.96875 359.375 361.191406 354.550781 362.96875 347.65625 C 365.515625 337.78125 369.4375 328.316406 374.609375 319.53125 C 378.234375 313.390625 377.25 305.570312 372.195312 300.53125 L 347.207031 275.527344 L 369.292969 253.441406 L 394.292969 278.4375 C 399.339844 283.484375 407.15625 284.472656 413.300781 280.851562 C 422.078125 275.671875 431.546875 271.753906 441.414062 269.199219 C 448.316406 267.425781 453.132812 261.203125 453.132812 254.082031 L 453.132812 218.75 L 484.382812 218.75 L 484.382812 254.097656 C 484.382812 261.21875 489.210938 267.441406 496.101562 269.21875 C 505.980469 271.765625 515.449219 275.6875 524.226562 280.859375 C 530.371094 284.484375 538.195312 283.5 543.238281 278.445312 L 568.238281 253.457031 L 590.328125 275.542969 L 565.332031 300.542969 C 560.292969 305.589844 559.296875 313.40625 562.921875 319.550781 C 568.089844 328.328125 572.015625 337.796875 574.5625 347.664062 C 576.34375 354.566406 582.570312 359.382812 589.691406 359.382812 L 625 359.382812 L 625 390.632812 L 589.652344 390.632812 C 582.53125 390.632812 576.308594 395.460938 574.53125 402.351562 C 571.984375 412.230469 568.0625 421.699219 562.890625 430.476562 C 559.265625 436.621094 560.25 444.445312 565.304688 449.488281 L 590.292969 474.488281 Z M 568.183594 496.453125 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.75 296.875 C 425.605469 296.875 390.625 331.855469 390.625 375 C 390.625 418.144531 425.605469 453.125 468.75 453.125 C 511.894531 453.125 546.875 418.144531 546.875 375 C 546.820312 331.875 511.875 296.929688 468.75 296.875 Z M 468.75 421.875 C 442.867188 421.875 421.875 400.882812 421.875 375 C 421.875 349.117188 442.867188 328.125 468.75 328.125 C 494.632812 328.125 515.625 349.117188 515.625 375 C 515.625 400.882812 494.632812 421.875 468.75 421.875 Z M 468.75 421.875 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramming);
export default __webpack_public_path__ + "static/media/programming.7f55bff5da6e9bbd07cb4a7bc2f4f839.svg";
export { ForwardRef as ReactComponent };